import { doDelete, doGet, doPost, doPut } from "../../api/baseAPI";
import { GROLOG_BASE_URL, GROLOG_URL } from "../../constant/apiConstant";
import { setTableLoading } from "../../store/reducer/page.reducer";
import { checkValidationToken } from "../../util/errorHandler";

export const dropdown = async (token, params) => {
  const url = `${GROLOG_URL}/depot-configuration/dropdown`;
  const result = { ok: false, list: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);

    if (res?.status === 200) {
      result.code = 200;
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }

  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
  }

  return result;
}

export const list = async (token, params) => {
  const url = `${GROLOG_URL}/delivery-associate`;
  const initiateUrl = `${GROLOG_URL}/delivery-associate/initiate`;

  const result = { ok: false, list: undefined, initiate: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);
    const resInitiate = await doGet(token, initiateUrl, params);

    if ((res?.status && resInitiate?.status) === 200) {
      result.code = 200;
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
      result.initiate = resInitiate?.data?.payload?.data;
    }
  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
    delete result.initiate;
  }
  return result;
}

export const detail = async (token, id) => {
  const url = `${GROLOG_URL}/delivery-associate/${id}`;
  const result = { ok: false, data: undefined, message: undefined }

  try {
    const res = await doGet(token, url);

    if (res?.status === 200) {
      result.ok = true;
      result.data = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }
  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.data;
  }
  return result
}

export const deleteDeliveryAssociate = async (token, id, body) => {
  const url = `${GROLOG_URL}/delivery-associate/${id}`
  const result = { ok: false, list: undefined, message: undefined, code: null }

  try {
    const res = await doDelete(url, token, body, '');

    if (res?.status === 200) {
      result.code = 200;
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }

  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
  }

  return result;
}

export const dropdownDriver = async (token, params) => {
  const url = `${GROLOG_URL}/vehicle-driver/dropdown-list`;
  const result = { ok: false, list: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);

    if (res?.status === 200) {
      result.code = 200;
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }

  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
  }

  return result;
}

export const detailDriver = async (token, id) => {
  const url = `${GROLOG_URL}/driver/${id}`;
  const result = { ok: false, data: undefined, message: undefined }

  try {
    const res = await doGet(token, url);

    if (res?.status === 200) {
      result.ok = true;
      result.data = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }
  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.data;
  }
  return result
}

export const detailVehicle = async (token, id) => {
  const url = `${GROLOG_URL}/vehicle/${id}`;
  const result = { ok: false, data: undefined, message: undefined }

  try {
    const res = await doGet(token, url);

    if (res?.status === 200) {
      result.ok = true;
      result.data = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }
  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.data;
  }
  return result
}

export const insert = async (token, refresh_token, data, params, dispatch) => {
  const result = { status: false, message: undefined }
  const url = `${GROLOG_URL}/delivery-associate`

  try {
    const res = await doPost(url, token, data, params)
    if (res) {
      result.status = true
      result.message = res?.data?.payload?.status?.message
    } else {
      result.status = false
      result.message = res.data.payload.message
    }
  } catch (error) {
    result.message = error.response.data.payload.message
    // checkValidationToken(error, token, refresh_token, dispatch)
  }

  return result
}

export const searchRecommendation = async (token, params) => {

  const url = `${GROLOG_URL}/delivery-associate/search`;
  let result = { data: undefined, ok: false }

  try {
    const response = await doGet(token, url, params);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.data
    }
  } catch (error) {
    console.log(error)
    // checkValidationToken(error, token, refresh_token, dispatch)
  }
  return result
}

export const getSearchResult = async (token, refresh_token, depot_id, keyword, dispatch) => {
  const url = `${GROLOG_URL}/delivery-associate?page=1&limit=10&filter=depot_id eq ${depot_id}, full_name lk ${keyword}`;
  let result = { data: undefined, ok: false }

  dispatch(setTableLoading(true))
  try {
    const response = await doGet(token, url, null);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.data
    }
  } catch (error) {
    checkValidationToken(error, token, refresh_token, dispatch)
  }
  dispatch(setTableLoading(false))
  return result
}

export const dropdownTemperatureCategory = async (token, params) => {
  const url = `${GROLOG_URL}/temperature-category/dropdown`;
  const result = { ok: false, list: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);

    if (res?.status === 200) {
      result.code = 200;
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }

  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
  }

  return result;
}

export const dropdownSkillSet = async (token, params) => {
  const url = `${GROLOG_URL}/skill-set/dropdown`;
  const result = { ok: false, list: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);

    if (res?.status === 200) {
      result.code = 200;
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }

  } catch (error) {
    const errorCode = error?.response?.status;
    const errorMessage = error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
  }

  return result;
}

export const getManagementHistoryList = async (token, refresh_token, dispatch, id) => {
  const url = `${GROLOG_BASE_URL}/audit/v1/grolog/audit?page=1&filter=table_name eq delivery_associate, primary_key eq ${id}`;
  let result = { data: undefined, ok: false }

  try {
      const response = await doGet(token, url, null);
      if (response) {
          result.ok = true;
          result.data = response?.data?.payload
      }
  } catch (error) {
      checkValidationToken(error, token, refresh_token, dispatch)
  }
  return result
}

export const updateData = async (token, id, data) => {
  const result = { status: false, message: undefined }
  const url = `${GROLOG_URL}/delivery-associate/${id}`

  try {
    const res = await doPut(url, token, data);
    if (res) {
      result.status = true
      result.message = res?.data?.payload?.message
    } else {
      result.status = false
      result.message = res?.data?.payload?.status?.message;
    }
  } catch (error) {
    result.message = error?.response?.data?.payload?.message
    // checkValidationToken(error, token, refresh_token, dispatch)
  }

  return result
}

